import { createContext } from 'react';

import type { ClientRouteContextValue } from '../types';

export const initialClientRouteContextValue: ClientRouteContextValue = {};
export const RouteContext = createContext(initialClientRouteContextValue);
